import {moduleType, wpHydration, wpHydrationType} from './Constants';

function transform(tagName, attribs)
{
    if ( attribs.type === moduleType || (attribs.type === wpHydrationType && attribs[wpHydration]) )
    {
        return {
            tagName: 'pre',
            attribs: {
                ...attribs,
                "data-toparse": "script",
                "style": "display:none"
            }
        }
    }
    return {
        tagName,
        attribs
    }
}

export default {
    transform
};